<mat-form-field appearance="outline" floatLabel="always">
  <mat-select [formControl]="control" [compareWith]="compareValues">
    <mat-option *ngFor="let option of truckOptions" [value]="option">
      {{ option.materialCode }}-{{ option.materialDescription }}
    </mat-option>
  </mat-select>
</mat-form-field>
